// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type {
    GetInspectionPointsAiPointByIdParam,
    BaseResponseInspectionPointFoundResponse,
} from '../../../types';

/**
 * 生成ai质检点
 *
 * @export
 * @tags 质检点
 * @link [GET] /inspectionPoints/aiPoint/{id}
 * @param id
 */
export function getInspectionPointsAiPointById(
    options: ApiOptions<GetInspectionPointsAiPointByIdParam, never> & {
        segments: GetInspectionPointsAiPointByIdParam;
    }
): Promise<BaseResponseInspectionPointFoundResponse> {
    return request<never, GetInspectionPointsAiPointByIdParam, never>(
        '/inspectionPoints/aiPoint/{id}',
        { ...options, method: 'get', __$requestCalleeName: 'getInspectionPointsAiPointById' }
    );
}

export const meta = [{ tags: ['质检点'], path: '/inspectionPoints/aiPoint/{id}', method: 'get' }];
